import {toggleClassWhenSticky} from '../utils/toggle-class-when-sticky';

export default function initHeaderInnovation() {
    const $headerHome = document.querySelector<HTMLElement>('.header');
    const $subHeaders = document.querySelectorAll<HTMLElement>('.sub-header');
    const $menuAncres = document.querySelector<HTMLElement>('.menu-ancres');
    //const $menuAncresEl = $menuAncres.querySelectorAll<HTMLElement>('.link-item');
    const $urlDepot = document.querySelector<HTMLInputElement>('#url-depot-projet');
    const $ctaDepot = document.querySelector<HTMLElement>('.cta-depot');
    const $body = document.body;

    const $ancres = document.querySelectorAll<HTMLElement>('.wp-block-acf-ancre');

    // intersection observer
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {

            // if 90% of <section> is visible (intersecting) then

            // respective <nav> element highlights
            // "90%" is our custom value
            // it is set in "rootMargin"

                if (entry.isIntersecting) {

                    console.log(entry.target.id);
                    const ancreActive = $menuAncres?.querySelector<HTMLElement>('a.active');

                    // remove class from anchor active
                    if (ancreActive) {
                        ancreActive.classList.remove('active');
                    }

                    $menuAncres?.querySelector<HTMLElement>('[href="#' + entry.target.id + '"]')?.classList.add('active');

                    /*// remove highlight from current "active" <nav> item
                    document.querySelector(`ul li.active`).classList.remove('active');

                    // get the index of currently intersecting section
                    activeSectionIndicator = entry.target.classList[0];

                    // highlight new active <nav> item
                    document
                        .querySelector(`ul li[data-section="${activeSectionIndicator}"]`)
                        .classList.add('active');*/
                }
            });
        },

        // options
        {
            root: document,
            rootMargin: '0px 0px -20% 0px',
            threshold: 1
        }
    );

    // loop for Intersection Observer JS
    $ancres.forEach((section) => {
        observer.observe(section);
    });

    if ($headerHome && $subHeaders.length > 0) {
        $headerHome.classList.add('add');
    }

    if ($urlDepot && $ctaDepot) {
        $ctaDepot.addEventListener('click', function (e) {
            e.preventDefault();
            location.href = $urlDepot.value;
        });
    }

    if ($menuAncres) {
        toggleClassWhenSticky($menuAncres, 'sticky-ancres', $menuAncres);
        toggleClassWhenSticky($menuAncres, 'is-sticky-ancres', $body);
    }
}
 